export default __webpack_public_path__ + "static/media/Poppins-Medium.673ed423.ttf";